<template>
  <v-container>
    <h1>BOBCAT FIRE INTAKE FORM</h1>
    <div v-if="formComplete">
      THANK YOU FOR YOUR SUBMISSION. SOMEONE WILL CONTACT YOU SHORTLY
    </div>
    <v-stepper v-model="e13" vertical non-linear v-if="!formComplete">
      <v-btn text style="background-color: #303030">
        <v-stepper-step step="1" complete @click="e13 = 1">
          CONTACT DETAILS
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="1">
        <v-card class="mb-5" light>
          <v-container class="ma-auto" max-width="80%">
            <v-form id="party" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>PRIMARY CONTACT</div>
                      <!-- NAME  -->
                      <v-layout row wrap class="ma-auto">
                        <v-text-field
                          label="FIRST NAME"
                          v-model="firstName"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                          autofocus
                        ></v-text-field>
                        <v-text-field
                          label="LAST NAME"
                          v-model="lastName"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                      <!-- PHONE AND EMAIL -->
                      <v-layout row wrap class="ma-auto">
                        <v-text-field
                          label="EMAIL"
                          v-model="email"
                          width="100%"
                          class="ma-2"
                          :rules="[rules.email]"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="PHONE"
                          v-model="phone"
                          width="100%"
                          class="ma-2"
                          v-mask="phoneMask"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                      <!-- PRIMARY?  -->
                      <v-layout row wrap class="ma-auto">
                        <v-radio-group
                          label="ARE YOU THE PRIMARY CONTACT FOR MATTERS RELATING TO THE FIRE?"
                          v-model="primary"
                          dense
                          outlined
                        >
                          <v-radio label="YES" :value="true"></v-radio>
                          <v-radio label="NO" :value="false"></v-radio>
                        </v-radio-group>
                      </v-layout>
                      <!-- IF NO PRIMARY PRIMARY  -->
                      <div v-if="primary !== null && primary !== true">
                        <v-container width="80%">
                          <div>
                            PLEASE PROVIDE THE PRIMARY CONTACT PERSON'S
                            INFORMATION BELOW
                          </div>
                          <v-layout row wrap class="ma-auto">
                            <v-text-field
                              label="PRIMARY FIRST NAME"
                              v-model="primaryFirstName"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-text-field>
                            <v-text-field
                              label="PRIMARY LAST NAME"
                              v-model="primaryLastName"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-text-field>
                          </v-layout>
                          <v-layout row wrap class="ma-auto">
                            <v-text-field
                              label="PRIMARY EMAIL"
                              v-model="primaryEmail"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-text-field>
                            <v-text-field
                              label="PHONE"
                              v-model="primaryPhone"
                              width="100%"
                              class="ma-2"
                              v-mask="phoneMask"
                              dense
                              outlined
                            ></v-text-field>
                          </v-layout>
                        </v-container>
                      </div>
                      <!-- DATE OF BIRTH  -->
                      <v-layout row wrap class="ma-auto">
                        <v-text-field
                          label="DATE OF BIRTH"
                          v-model="dateOfBirth"
                          width="100%"
                          class="ma-2"
                          v-mask="dateMask"
                          dense
                          outlined
                        ></v-text-field>
                        <v-select
                          class="ma-2"
                          :items="primaryContactOptions"
                          v-model="primaryPreferredMethodOfContact"
                          label="PREFERRED METHOD OF CONTACT"
                          dense
                          outlined
                        ></v-select>
                      </v-layout>
                      <!-- MINORS?  -->
                      <v-layout row wrap class="ma-auto">
                        <v-radio-group
                          label="ARE ANY MINORS/CHILDREN INVOLVED WITH YOUR CLAIM?"
                          v-model="minorsInvolved"
                          dense
                          outlined
                        >
                          <v-radio label="YES" :value="true"></v-radio>
                          <v-radio label="NO" :value="false"></v-radio>
                        </v-radio-group>
                      </v-layout>
                      <!-- IF MINORS   -->
                      <v-expand-transition>
                        <div
                          v-if="
                            minorsInvolved !== null && minorsInvolved === true
                          "
                        >
                          <v-container width="80%">
                            <div>
                              PLEASE PROVIDE EACH MINOR'S INFORMATION (CLICK
                              "ADD")
                            </div>
                            <v-card>
                              <v-layout row wrap class="ma-auto">
                                <v-text-field
                                  label="MINOR'S FIRST NAME"
                                  v-model="minorFirstName"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="MINOR'S LAST NAME"
                                  v-model="minorLastName"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="AGE"
                                  v-model="minorAge"
                                  width="20%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="ENTER FULL NAME OF GUARDIAN"
                                  v-model="minorGuardianName"
                                  width="20%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-select
                                  label="GENDER"
                                  v-model="minorGender"
                                  :items="genderOptions"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-select>
                              </v-layout>

                              <v-layout row wrap class="ma-auto">
                                <v-text-field
                                  label="DATE OF BIRTH"
                                  v-model="minorDateOfBirth"
                                  width="100%"
                                  class="ma-2"
                                  v-mask="dateMask"
                                  hint="DD/MM/YYYY"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="RELATION TO YOU"
                                  v-model="minorRelation"
                                  width="20%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-container>
                                  <v-radio-group
                                    label="HAS THIS MINOR SOUGHT MEDICAL OR MENTAL HEALTH CARE AS A RESULT OF THE FIRE?"
                                    v-model="minorInjured"
                                  >
                                    <v-radio
                                      label="YES"
                                      :value="true"
                                    ></v-radio>
                                    <v-radio
                                      label="NO"
                                      :value="false"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-container>
                              </v-layout>
                              <v-card-actions>
                                <v-btn
                                  rounded
                                  color="green"
                                  @click="addMinorToMinors"
                                  >ADD</v-btn
                                >
                              </v-card-actions>
                              <v-card
                                v-if="minors.length > 0"
                                min-height="60px"
                              >
                                <div>ADDED MINORS:</div>
                                <div v-for="(minor, i) in minors" :key="i">
                                  <v-layout class="ma-1" row wrap>
                                    <div class="title">{{ minor.name }}</div>
                                    <div>
                                      <v-btn
                                        small
                                        text
                                        rounded
                                        color="red"
                                        @click="removeMinor(i)"
                                        >remove</v-btn
                                      >
                                    </div>
                                  </v-layout>
                                </div>
                              </v-card>
                            </v-card>
                          </v-container>
                        </div>
                      </v-expand-transition>
                      <!-- OTHER ADULTS?  -->
                      <v-layout row wrap class="ma-auto">
                        <v-radio-group
                          label="ARE ANY OTHER ADULTS AFFILIATED WITH YOUR CLAIM?"
                          v-model="otherAdultAffiliatedWithClaim"
                        >
                          <v-radio label="YES" :value="true"></v-radio>
                          <v-radio label="NO" :value="false"></v-radio>
                        </v-radio-group>
                      </v-layout>
                      <v-expand-transition>
                        <div
                          v-if="
                            otherAdultAffiliatedWithClaim !== null &&
                              otherAdultAffiliatedWithClaim === true
                          "
                        >
                          <v-container width="80%">
                            <div>
                              PLEASE PROVIDE EACH OTHER ADULT PLAINTIFF'S
                              INFORMATION (CLICK "ADD")
                            </div>
                            <v-card>
                              <v-layout row wrap class="ma-auto">
                                <v-text-field
                                  label="FIRST NAME"
                                  v-model="otherAdultFirstName"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="LAST NAME"
                                  v-model="otherAdultLastName"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-select
                                  label="GENDER"
                                  v-model="otherAdultGender"
                                  :items="genderOptions"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-select>
                              </v-layout>

                              <v-layout row wrap class="ma-auto">
                                <v-text-field
                                  label="DATE OF BIRTH"
                                  v-model="otherAdultDateOfBirth"
                                  width="100%"
                                  class="ma-2"
                                  v-mask="dateMask"
                                  hint="DD/MM/YYYY"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="PHONE"
                                  v-model="otherAdultPhone"
                                  width="100%"
                                  class="ma-2"
                                  v-mask="phoneMask"
                                  hint="(###) ###-####"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="EMAIL"
                                  v-model="otherAdultEmail"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="RELATION TO YOU"
                                  v-model="otherAdultRelation"
                                  width="20%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-container>
                                  <v-radio-group
                                    label="HAS THIS PERSON SOUGHT MEDICAL OR MENTAL HEALTH CARE AS A RESULT OF THE FIRE?"
                                    v-model="otherAdultInjured"
                                    dense
                                    outlined
                                  >
                                    <v-radio
                                      label="YES"
                                      :value="true"
                                    ></v-radio>
                                    <v-radio
                                      label="NO"
                                      :value="false"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-container>
                              </v-layout>
                              <v-card-actions>
                                <v-btn
                                  rounded
                                  color="green"
                                  @click="addAdultToAdults"
                                  >ADD</v-btn
                                >
                              </v-card-actions>
                              <v-card
                                v-if="otherAdults.length > 0"
                                min-height="60px"
                              >
                                <div>ADDED ADULTS:</div>
                                <div v-for="(adult, i) in otherAdults" :key="i">
                                  <v-layout class="ma-1" row wrap>
                                    <div class="title">{{ adult.name }}</div>
                                    <div>
                                      <v-btn
                                        small
                                        text
                                        rounded
                                        color="red"
                                        @click="removeOtherAdult(i)"
                                        >remove</v-btn
                                      >
                                    </div>
                                  </v-layout>
                                </div>
                              </v-card>
                            </v-card>
                          </v-container>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-flex>

                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>CURRENT ADDRESS</div>
                      <v-layout row wrap class="ma-2">
                        <v-text-field
                          label="STREET ADDRESS"
                          v-model="streetAddress"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="CITY"
                          v-model="city"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="STATE"
                          v-model="state"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="ZIP"
                          v-model="zipCode"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                      <div>MAILING ADDRESS ADDRESS</div>
                      <v-checkbox
                        v-model="currentAddressSameAsMailing"
                        label="Same as Current Address"
                      ></v-checkbox>
                      <v-layout row wrap class="ma-2">
                        <v-text-field
                          label="STREET ADDRESS"
                          v-model="mailingStreetAddress"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="CITY"
                          v-model="mailingCity"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="STATE"
                          v-model="mailingState"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="ZIP"
                          v-model="mailingZipCode"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>

        <v-btn color="primary" @click="e13 = 2">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>

      <v-btn text style="background-color: #303030">
        <v-stepper-step step="2" complete @click="e13 = 2">
          SECONDARY CONTACT
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="2">
        <v-card class="mb-5" light>
          <v-container class="ma-auto" max-width="80%">
            <v-form id="secondary" autocomplete="off">
              <v-container width="80%">
                <!-- NAME  -->
                <v-layout row wrap class="ma-auto">
                  <v-text-field
                    label="SECNDARY CONTACT FIRST NAME"
                    v-model="secondaryFirstName"
                    width="100%"
                    class="ma-2"
                    dense
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="SECNDARY CONTACT LAST NAME"
                    v-model="secondaryLastName"
                    width="100%"
                    class="ma-2"
                    dense
                    outlined
                  ></v-text-field>
                </v-layout>
                <!-- EMAIL  -->
                <v-layout row wrap class="ma-auto">
                  <v-text-field
                    label="SECONDARY CONTACT EMAIL"
                    v-model="secondaryEmail"
                    width="100%"
                    class="ma-2"
                    :rules="[rules.email]"
                    dense
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="SECNDARY CONTACT PHONE"
                    v-model="secondaryPhone"
                    width="100%"
                    class="ma-2"
                    v-mask="phoneMask"
                    dense
                    outlined
                  ></v-text-field>
                  <v-select
                    class="ma-2"
                    :items="primaryContactOptions"
                    v-model="secondaryPreferredMethodOfContact"
                    label="PREFERRED METHOD OF CONTACT"
                    dense
                    outlined
                  ></v-select>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>

        <v-btn color="primary" @click="e13 = 3">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>

      <v-btn text style="background-color: #303030">
        <v-stepper-step step="3" complete @click="e13 = 3">
          LOCATION OF THE LOSS
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="3">
        <v-card class="mb-5" light>
          <v-container class="ma-auto" max-width="80%">
            <v-form id="location" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>RELATIONSHIP TO THE LOSS LOCATION</div>
                      <v-radio-group
                        label="SELECT ONE"
                        v-model="relationshipToLossLocation"
                        dense
                        outlined
                      >
                        <div
                          v-for="(option,
                          i) in relationshipToLossLocationOptions"
                          :key="i"
                        >
                          <v-radio
                            :label="option"
                            :value="option"
                            class="ma-2"
                          ></v-radio>
                        </div>
                        <div v-if="relationshipToLossLocation === 'Other'">
                          <v-text-field
                            label="DESCRIBE"
                            v-model="otherRelationshipToLossLocation"
                            width="100%"
                            class="ma-2"
                            dense
                            outlined
                          ></v-text-field>
                        </div>
                      </v-radio-group>
                    </v-card>
                  </v-flex>
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>LOSS LOCATION ADDRESS</div>

                      <v-layout row wrap class="ma-2">
                        <v-text-field
                          label="STREET ADDRESS"
                          v-model="lossLocationStreetAddress"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="CITY"
                          v-model="lossLocationCity"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="STATE"
                          v-model="lossLocationState"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                        <v-text-field
                          label="ZIP"
                          v-model="lossLocationZipCode"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>LOSS LOCATION DETAILS</div>
                      <v-layout row wrap class="ma-2">
                        <v-text-field
                          label="APPROX. SIZE OF HOME"
                          v-model="lossLocationHomeSize"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                          hint="(IN SQRAURE FOOTAGE)"
                        ></v-text-field>

                        <v-text-field
                          label="NUMBER OF BEDROOMS AND BATHROOMS"
                          v-model="lossLocationNumberOfRooms"
                          class="ma-2"
                          dense
                          outlined
                          hint="#BED, #BATH"
                        ></v-text-field>
                      </v-layout>
                      <v-layout row wrap class="ma-2">
                        <v-text-field
                          label="APPROX. SIZE OF LOT"
                          v-model="lossLocationLotSize"
                          class="ma-2"
                          dense
                          outlined
                          hint="(IN SQRAURE FOOTAGE)"
                        ></v-text-field>
                        <v-text-field
                          label="APN #"
                          v-model="lossLocationAPNnumber"
                          class="ma-2"
                          dense
                          outlined
                        ></v-text-field>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>ADDITIONAL OR RELATED LOSS LOCATION(S)</div>
                      <v-layout row wrap class="ma-2">
                        <v-textarea
                          label="COMPLETE DESCRIPTION"
                          v-model="additionalLossLocations"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                          hint="INCLUDE YOUR RELATIONSHIP TO PROPERTY, STRUCTURE SIZE, NUMBER OF ROOMS, LOT SIZE"
                        ></v-textarea>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>

        <v-btn color="primary" @click="e13 = 4">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>

      <v-btn text style="background-color: #303030">
        <v-stepper-step step="4" complete @click="e13 = 4">
          TYPE OF LOSS
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="4">
        <v-card class="mb-5" light>
          <v-container class="ma-auto" max-width="80%">
            <v-form id="location" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>WHAT KIND OF LOSS DID YOU INCURE?</div>
                      <v-expansion-panels inset multiple>
                        <!-- DWELLING (HOME)  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >DWELLING (HOME)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Total Loss"
                              v-model="losses"
                              value="Dwelling (Home) - Total Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Partial Structure Loss"
                              v-model="losses"
                              value="Dwelling (Home) - Partial Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Smoke Damage Only"
                              v-model="losses"
                              value="Dwelling (Home) - Smoke Damage Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="No Loss"
                              v-model="losses"
                              value="Dwelling (Home) - No Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="dwellingOther"
                            ></v-checkbox>
                            <v-textarea
                              label="PLEASE DESCRIBE THE LOSS"
                              v-model="otherDwellingDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              hint="INCLUDE YOUR RELATIONSHIP TO PROPERTY, STRUCTURE SIZE, NUMBER OF ROOMS, LOT SIZE"
                              v-if="dwellingOther"
                            ></v-textarea>
                            <v-btn
                              v-if="otherDwellingDamage"
                              @click="addOtherDwellingDamage"
                              >done</v-btn
                            >
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- OTHER STRUCTURES (UNATTACHED TO THE HOME) -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >OTHER STRUCTURES (UNATTACHED TO THE
                            HOME)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Total Loss"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - Total Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Partial Structure Loss"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - Partial Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Smoke Damage Only"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - Smoke Damage Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="No Loss"
                              v-model="losses"
                              value="Other Structures (Unattached to the Home) - No Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="structureOther"
                            ></v-checkbox>
                            <v-textarea
                              label="PLEASE DESCRIBE THE LOSS"
                              v-model="otherStructureDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              hint="INCLUDE YOUR RELATIONSHIP TO PROPERTY, STRUCTURE SIZE, NUMBER OF ROOMS, LOT SIZE"
                              v-if="structureOther"
                            ></v-textarea>
                            <v-btn
                              v-if="structureOther"
                              @click="addOtherStructureDamage"
                              >done</v-btn
                            >
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- CONTENTS/PERSONAL PROPERTY  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >CONTENTS/PERSONAL
                            PROPERTY</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Many Contents Lost"
                              v-model="losses"
                              value="Contents/Personal Property - Many Contents Lost"
                            ></v-checkbox>
                            <v-checkbox
                              label="Some Contents Lost"
                              v-model="losses"
                              value="Contents/Personal Property - Some Contents Lost"
                            ></v-checkbox>
                            <v-checkbox
                              label="Smoke Damage/Spoiled Contents Only"
                              v-model="losses"
                              value="Contents/Personal Property - Smoke Damage/Spoiled Contents Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="contentsOther"
                            ></v-checkbox>
                            <v-textarea
                              label="PLEASE DESCRIBE THE LOSS"
                              v-model="otherContentDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              v-if="contentsOther"
                            ></v-textarea>
                            <v-btn
                              v-if="contentsOther"
                              @click="addOtherContentDamage"
                              >done</v-btn
                            >
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- VEHICLE(S)  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >VEHICLE(S)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Multiple Vehicles Lost"
                              v-model="losses"
                              value="Vehicles - Multiple Vehicles Lost"
                            ></v-checkbox>
                            <v-checkbox
                              label="One Vehicle Lost"
                              v-model="losses"
                              value="Vehicles - One Vehicle Lost"
                            ></v-checkbox>
                            <v-checkbox
                              label="No Loss"
                              v-model="losses"
                              value="Vehicles - No Loss"
                            ></v-checkbox>
                            <v-expand-transition>
                              <v-card class="ma-auto">
                                <div>
                                  PLEASE PROVIDE DETAILS OF EACH VEHICLE LOST
                                  (CLICK 'ADD')
                                </div>
                                <v-textarea
                                  label="PLEASE DESCRIBE THE VEHICLE"
                                  v-model="vehicleDamage.description"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-textarea>
                                <v-text-field
                                  label="INSURER"
                                  v-model="vehicleDamage.insurer"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-text-field
                                  label="POLICY NUMBER"
                                  v-model="vehicleDamage.policyNumber"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-text-field>
                                <v-textarea
                                  label="HAVE YOU BEEN COMPENSATED IN ANY WAY FOR THIS VEHICLE? PLEASE DESCRIBE"
                                  v-model="vehicleDamage.compensation"
                                  width="100%"
                                  class="ma-2"
                                  dense
                                  outlined
                                ></v-textarea>
                                <v-btn
                                  rounded
                                  color="green"
                                  @click="addVehicleDamage"
                                  >ADD</v-btn
                                >
                                <!-- <div v-for="(vehicle, i) in vehicles" :key="i"> -->
                                <v-container>
                                  <v-card
                                    class="ma-auto"
                                    v-for="(vehicle, i) in vehicles"
                                    :key="i"
                                  >
                                    <v-layout row wrap>
                                      <div class="ma-2">
                                        {{ vehicle.description }}
                                      </div>
                                      <div class="ma-2">
                                        <v-btn
                                          small
                                          rounded
                                          text
                                          @click="removeVehicle(i)"
                                          color="red"
                                          >remove</v-btn
                                        >
                                      </div>
                                    </v-layout>
                                  </v-card>
                                </v-container>
                              </v-card>
                            </v-expand-transition>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- LANDSCAPING  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >LANDSCAPING (INCLUDING
                            TREES)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Total Loss"
                              v-model="losses"
                              value="Landscaping - Total Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Partial Loss"
                              v-model="losses"
                              value="Landscaping - Partial Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Heat Damage Only"
                              v-model="losses"
                              value="Landscaping - Heat Damage Only"
                            ></v-checkbox>
                            <v-checkbox
                              label="No Loss"
                              v-model="losses"
                              value="Landscaping - No Loss"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="landscapingOther"
                            ></v-checkbox>
                            <v-text-field
                              label="PLEASE DESCRIBE"
                              v-model="otherLandscapingDamage"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                              v-if="landscapingOther"
                            ></v-text-field>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR LANDSCAPING LOSS"
                              v-model="landscapingDamageDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- INCOME/BUSINESS LOSS  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >INCOME/BUSINESS LOSS</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Lost use of Physical Business Property"
                              v-model="losses"
                              value="Income - Business - Lost use of Physical Business Property"
                            ></v-checkbox>
                            <v-checkbox
                              label="Loss of Future Profits (including Loss of Rent)"
                              v-model="losses"
                              value="Income - Business - Loss of Future Profits (including Loss of Rent)"
                            ></v-checkbox>
                            <v-checkbox
                              label="Damage to Business Equipment"
                              v-model="losses"
                              value="Income - Business - Damage to Business Equipment"
                            ></v-checkbox>
                            <v-checkbox
                              label="Damage to Business Goodwill and/or Brand"
                              v-model="losses"
                              value="Income - Business - Damage to Business Goodwill and - or Brand"
                            ></v-checkbox>
                            <v-checkbox
                              label="Loss of Income"
                              v-model="losses"
                              value="Income - Business - Loss of Income"
                            ></v-checkbox>
                            <v-checkbox
                              label="Other"
                              v-model="incomeLossOther"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR INCOME/BUSINESS LOSS"
                              v-model="otherIncomeLoss"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- EVACUATION COSTS  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >EVACUATION COSTS</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Evacuation Costs"
                              v-model="losses"
                              value="Evacuation Loss"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR EVACUATION LOSS"
                              v-model="evacuationCostDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- PERSONAL INJURY -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >PERSONAL INJURY</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Personal Injury"
                              v-model="losses"
                              value="Personal Injury"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR INJURIES"
                              v-model="personalInjuryDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- EMOTIONAL DISTRESS/ANNOYANCE -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >EMOTIONAL
                            DESTRESS/ANNOYANCE</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Emotional Distress/Annoyance"
                              v-model="losses"
                              value="Emotional Distress"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE YOUR EMOTIONAL DISTRESS AND/OR ANNOYANCE"
                              v-model="emotionalDistressDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- HARM TO PETS OR LIVESTOCK -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >HARM TO PETS OR LIVESTOCK</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Harm to Pets or Livestock"
                              v-model="losses"
                              value="Harm to Pets or Livestock"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE THE HARM TO PETS OR LIVESTOCK"
                              v-model="harmToPetsDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- DAMAGE TO CROPS GROWN FOR PROFIT (INCLUDING VINYARDS) -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >DAMAGE TO CROPS GROWN FOR PROFIT (INCLUDING
                            VINYARDS)</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Damage to Crops Grown for Profit (including Vineyards)"
                              v-model="losses"
                              value="Damage to Crops Grown for Profit (including Vineyards)"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE THE DAMAGE TO CROPS GROWN FOR PROFIT"
                              v-model="damageToCropsForProfitDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- OTHER LOSSES  -->
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            >OTHER LOSSES</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <v-checkbox
                              label="Other Losses"
                              v-model="losses"
                              value="Other Losses"
                            ></v-checkbox>
                            <v-textarea
                              label="BRIEFLY DESCRIBE OTHER LOSSES NOT LISTED"
                              v-model="otherLossDescription"
                              width="100%"
                              class="ma-2"
                              dense
                              outlined
                            ></v-textarea>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
        <v-btn color="primary" @click="e13 = 5">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>

      <v-btn text style="background-color: #303030">
        <v-stepper-step step="5" complete @click="e13 = 5">
          INSURANCE/COMPENSATION INFORMATION
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="5">
        <v-card class="mb-5" light>
          <v-container class="ma-auto" max-width="80%">
            <v-form id="party" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>INURANCE INFORMAITON</div>

                      <v-layout row wrap class="ma-auto">
                        <v-radio-group
                          label="DID YOU HAVE AN INSURANCE POLICY FOR YOUR HOME AND/OR PERSONAL CONTENTS AT THE TIME OF THE FIRE?"
                          v-model="insuranceCoverage"
                          dense
                          outlined
                        >
                          <v-radio label="YES" :value="true"></v-radio>
                          <v-radio label="NO" :value="false"></v-radio>
                        </v-radio-group>
                      </v-layout>

                      <!-- IF INSURANCE  -->
                      <v-expand-transition>
                        <div
                          v-if="
                            insuranceCoverage !== null &&
                              insuranceCoverage !== false
                          "
                        >
                          <v-container width="80%">
                            <div>
                              PLEASE PROVIDE YOUR INSURANCE INFORMATION BELOW
                            </div>
                            <v-layout row wrap class="ma-auto">
                              <v-text-field
                                label="INSURANCE CARRIER"
                                v-model="insuranceCarrier"
                                width="100%"
                                class="ma-2"
                                dense
                                outlined
                              ></v-text-field>
                              <v-text-field
                                label="TYPE OF POLICY"
                                v-model="policyType"
                                width="100%"
                                class="ma-2"
                                dense
                                outlined
                                hint="Ex: Home Owner's/ Renter's"
                              ></v-text-field>
                            </v-layout>
                            <v-layout row wrap class="ma-auto">
                              <v-text-field
                                label="POLICY NUMBER"
                                v-model="policyNumber"
                                width="100%"
                                class="ma-2"
                                dense
                                outlined
                              ></v-text-field>
                            </v-layout>

                            <v-layout row wrap class="ma-auto">
                              <v-textarea
                                label="PLEASE DESCRIBE ANY COMPENSATION YOU HAVE RECEIVED"
                                v-model="insuranceCompensationDescription"
                                width="100%"
                                class="ma-2"
                                dense
                                outlined
                              ></v-textarea>
                            </v-layout>
                          </v-container>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-flex>
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <div>DISASTER RELIEF PROGRAM ASSISTANCE</div>

                      <v-layout row wrap class="ma-auto">
                        <v-radio-group
                          label="DID YOU RECEIVE ASSISTANCE FROM FEMA OR ANY OTHER DISASTER RELIEF PROGRAM?"
                          v-model="femaAssistance"
                          dense
                          outlined
                        >
                          <v-radio label="YES" :value="true"></v-radio>
                          <v-radio label="NO" :value="false"></v-radio>
                        </v-radio-group>
                      </v-layout>

                      <!-- IF FEMA ASSISTANCE  -->
                      <v-expand-transition>
                        <div
                          v-if="
                            femaAssistance !== null && femaAssistance !== false
                          "
                        >
                          <v-container width="80%">
                            <div>
                              PLEASE EXPLAIN
                            </div>
                            <v-layout row wrap class="ma-auto">
                              <v-textarea
                                label="DISASTER RELIEF EXPLANATION"
                                v-model="femaAssistaceDescription"
                                width="100%"
                                class="ma-2"
                                dense
                                outlined
                              ></v-textarea>
                            </v-layout>
                          </v-container>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>

        <v-btn color="primary" @click="e13 = 6">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>
      <v-btn text style="background-color: #303030">
        <v-stepper-step step="6" complete @click="e13 = 6">
          MISCELLANEOUS
        </v-stepper-step>
      </v-btn>

      <v-stepper-content step="6">
        <v-card class="mb-5" light>
          <v-container class="ma-auto" max-width="80%">
            <v-form id="party" autocomplete="off">
              <v-container width="80%">
                <v-layout row wrap class="ma-auto">
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <v-layout row wrap class="ma-auto">
                        <v-textarea
                          label="DO YOU OR ANYONE YOU KNOW BELIEVE THAT YOU SAW THE START OF THE FIRE? PLAESE EXPLAIN"
                          v-model="fireStarter"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-textarea>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex class="ma-2">
                    <v-card class="ma-auto">
                      <v-layout row wrap class="ma-auto">
                        <v-textarea
                          label="HOW DID YOU FIRST HEAR ABOUT OUR SERVICES? PLAESE EXPLAIN"
                          v-model="howDidYouHearAboutUs"
                          width="100%"
                          class="ma-2"
                          dense
                          outlined
                        ></v-textarea>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>

        <v-btn color="primary" @click="e13 = 1">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>

      <!-- <v-btn @click="logLosses"></v-btn> -->

      <!-- <v-stepper-step :rules="[() => false]" step="3">
        Ad templates
        <small>Alert message</small>
      </v-stepper-step> -->

      <!-- <v-stepper-content step="3">
        <v-card color="grey lighten-1" class="mb-5" height="200px"></v-card>
        <v-btn color="primary" @click="e13 = 4">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content> -->

      <!-- <v-stepper-step step="4">View setup instructions</v-stepper-step>

      <v-stepper-content step="4">
        <v-card color="grey lighten-1" class="mb-5" height="200px"></v-card>
        <v-btn color="primary" @click="e13 = 1">Continue</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content> -->
      <v-card-actions>
        <v-progress-circular
          class="text-center ma-auto"
          indeterminate
          size="84"
          v-if="overlay"
        ></v-progress-circular
        ><v-btn
          :disabled="overlay"
          @click="submit"
          rounded
          outlined
          color="green"
          text
          >SUBMIT</v-btn
        ></v-card-actions
      >
    </v-stepper>
  </v-container>
</template>

<script>
import * as firebase from "firebase";
import * as moment from "moment";
import { mask } from "vue-the-mask";
import slugify from "slugify";

export default {
  directives: {
    mask
  },
  data: () => ({
    e13: 1,
    primary: null,
    phoneMask: "(###) ###-####",
    dateMask: "##/##/####",
    submissionDate: moment().format("LL"),
    firstName: null,
    lastName: null,
    phone: null,
    dateOfBirth: null,
    email: null,
    streetAddress: null,
    city: null,
    state: null,
    zipCode: null,
    //if mailing different from current address
    mailingStreetAddress: null,
    mailingCity: null,
    mailingState: null,
    mailingZipCode: null,
    primaryPreferredMethodOfContact: null,
    primaryContactOptions: ["Email", "Phone", "Mail", "In Person"],
    //if client is not primary contact
    primaryContact: true,
    primaryFirstName: null,
    primaryLastName: null,
    primaryDateOfBirth: null,
    primaryEmail: null,
    primaryPhone: null,
    minorsInvolved: null,
    //if minors involved
    minors: [],
    minorFirstName: null,
    minorLastName: null,
    minorGuardianName: null,
    minorAge: null,
    minorGender: null,
    minorDateOfBirth: null,
    minorRelation: null,
    minorInjured: null,
    genderOptions: ["Male", "Female", "Decline"],
    otherAdultAffiliatedWithClaim: null,
    //if other adults affiliated
    otherAdults: [],
    otherAdultFirstName: null,
    otherAdultLastName: null,
    otherAdultPhone: null,
    otherAdultEmail: null,
    otherAdultAge: null,
    otherAdultGender: null,
    otherAdultDateOfBirth: null,
    otherAdultRelation: null,
    otherAdultInjured: null,
    // otherAdultGenderOptions: ["Male", "Female", "Decline"],
    //if secondary contact
    secondaryContact: false,
    secondaryFirstName: null,
    secondaryLastName: null,
    secondaryEmail: null,
    secondaryPhone: null,
    secondaryPreferredMethodOfContact: null,
    showVehicle: false,
    // secondaryContactOptions: ["Email", "Phone", "Mail", "In Person"],
    relationshipToLossLocation: null,
    relationshipToLossLocationOptions: [
      "Owner",
      "Renter/Lessee",
      "Other Resident",
      "Your Workplace",
      "Lienholder",
      "Easement-holder",
      "Other"
    ],
    otherRelationshipToLossLocation: null,
    lossLocationStreetAddress: null,
    lossLocationCity: null,
    lossLocationState: null,
    lossLocationZipCode: null,

    lossLocationHomeSize: null,
    lossLocationLotSize: null,
    lossLocationNumberOfRooms: null,
    lossLocationAPNnumber: null,
    currentAddressSameAsMailing: false,
    additionalLossLocations: null,

    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    },
    losses: [],
    dwellingOther: false,
    structureOther: false,
    contentsOther: false,
    landscapingOther: false,
    incomeLossOther: false,

    otherDwellingDamage: null,
    otherStructureDamage: null,
    otherContentDamage: null,
    otherLandscapingDamage: null,
    landscapingDamageDescription: null,
    evacuationCostDescription: null,
    personalInjuryDescription: null,
    emotionalDistressDescription: null,
    harmToPetsDescription: null,
    damageToCropsForProfitDescription: null,
    otherLossDescription: null,
    otherIncomeLoss: null,
    vehicleDamage: {
      description: null,
      insurer: null,
      policyNumber: null,
      compensation: null
    },
    vehicles: [],
    insuranceCoverage: null,
    insuranceCarrier: null,
    policyType: null,
    policyNumber: null,
    insuranceCompensationDescription: null,
    femaAssistance: null,
    femaAssistaceDescription: null,
    fireStarter: null,
    howDidYouHearAboutUs: null,
    overlay: false,
    formComplete: false
  }),
  methods: {
    submit() {
      //take each plaintiff and add to a plaintiff's array
      this.overlay = true;
      let plaintiffs = this.plaintiffs; //look at computed property
      let defendants = [
        {
          fullName: `Southern California Edison`,
          addressLine1: null,
          cityStateZip: null,
          phone: null,
          email: null,
          attorney: null,
          dateOfBirth: null,
          type: "business",
          insurance: null
        }
      ];

      //add vehicles to losses
      this.vehicles.forEach(car => {
        this.losses.push(car);
      });

      let intakeResponses = {
        firstName: this.firsName,
        lastName: this.lastName,
        submissionDate: this.submissionDate,
        phone: this.phone,
        dateOfBirth: this.dateOfBirth,
        email: this.email,
        streetAddress: this.streetAddress,
        city: this.city,
        state: this.state,
        zipCode: this.zipCode,
        mailingStreetAddress: this.mailingStreetAddress,
        mailingCity: this.mailingCity,
        mailingState: this.mailingState,
        mailingZipCode: this.mailingZipCode,
        primaryPreferredMethodOfContact: this.primaryPreferredMethodOfContact,
        primaryContact: this.primaryContact,
        primaryFirstName: this.primaryFirstName,
        primaryLastName: this.primaryLastName,
        primaryEmail: this.primaryEmail,
        primaryPhone: this.primaryPhone,
        minorsInvolved: this.minorsInvolved,
        minors: this.minors,
        otherAdultAffiliatedWithClaim: this.otherAdultAffiliatedWithClaim,
        otherAdults: [],
        secondaryContact: this.secondaryContact,
        secondaryFirstName: this.secondaryFirstName,
        secondaryLastName: this.secondaryLastName,
        secondaryEmail: this.secondaryEmail,
        secondaryPhone: this.secondaryPhone,
        secondaryPreferredMethodOfContact: this
          .secondaryPreferredMethodOfContact,
        relationshipToLossLocation: this.relationshipToLossLocation,
        otherRelationshipToLossLocation: null,
        lossLocationStreetAddress: this.lossLocationStreetAddress,
        lossLocationCity: this.lossLocationCity,
        lossLocationState: this.lossLocationState,
        lossLocationZipCode: this.lossLocationZipCode,

        lossLocationHomeSize: this.lossLocationHomeSize,
        lossLocationLotSize: this.lossLocationLotSize,
        lossLocationNumberOfRooms: this.lossLocationNumberOfRooms,
        lossLocationAPNnumber: this.lossLocationAPNnumber,
        currentAddressSameAsMailing: this.currentAddressSameAsMailing,
        additionalLossLocations: this.additionalLossLocations,
        losses: this.losses,
        dwellingOther: this.dwellingOther,
        structureOther: this.structureOther,
        contentsOther: this.contentsOther,
        landscapingOther: this.landscapingOther,
        incomeLossOther: this.incomeLossOther,

        otherDwellingDamage: this.otherDwellingDamage,
        otherStructureDamage: this.otherStructureDamage,
        otherContentDamage: this.otherContentDamage,
        otherLandscapingDamage: this.otherLandscapingDamage,
        landscapingDamageDescription: this.landscapingDamageDescription,
        evacuationCostDescription: this.evacuationCostDescription,
        personalInjuryDescription: this.personalInjuryDescription,
        emotionalDistressDescription: this.emotionalDistressDescription,
        harmToPetsDescription: this.harmToPetsDescription,
        damageToCropsForProfitDescription: this
          .damageToCropsForProfitDescription,
        otherLossDescription: this.otherLossDescription,
        otherIncomeLoss: this.otherIncomeLoss,
        vehicles: this.vehicles,
        insuranceCoverage: null,
        insuranceCarrier: this.insuranceCarrier,
        policyType: this.policyType,
        policyNumber: this.policyNumber,
        insuranceCompensationDescription: this.insuranceCompensationDescription,
        femaAssistance: this.femaAssistance,
        femaAssistaceDescription: this.femaAssistaceDescription,
        fireStarter: this.fireStarter,
        howDidYouHearAboutUs: this.howDidYouHearAboutUs
      };

      //create the matter object and send to cloud function
      let caseName = `Bobcat Fire Cases - ${this.primaryLastName} Household`;
      // let alias = `Bobcat Fire ${this.primaryLastName} ${this.dateOfBirth}`;
      let alias = `Bobcat Fire ${this.primaryFirstName} ${this.primaryLastName} Household`;
      let matterSlug = slugify(alias, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });
      let newMatter = {
        caseName,
        caseNumber: null,
        dateOfLoss: `2021-09-06`,
        statuteOfLimitations: null,
        complaintDeadline: null,
        dateOfComplaint: null,
        internalID: null,
        causesOfAction: ["NEGLIGENCE"],
        coordinationProceeding: true,
        specialTitle: `Bobcat Fire Cases`,
        status: `steady`,
        dateCreated: moment().format("MMMM Do YYYY, h:mm:ss a"),
        creatorID: `nrajamand@elllaw.com`,
        notes: [],
        activities: [],
        attorneys: [],
        matterSlug: matterSlug,
        jdxState: `California`,
        jdxCounty: `Los Angeles`,
        jdxCourtHouseName: null,
        jdxCourtHouseStreetAddressLine1: null,
        jdxCourtHouseCity: null,
        jdxCourtHouseState: `California`,
        jdxCourtHouseZip: null,
        jdxDepartment: null,
        jdxJudge: null,
        caseDocs: {
          initialDocs: []
        },
        plaintiffs: plaintiffs,
        defendants: defendants,
        sharedWith: ["vghica@elllaw.com", "nrajamand@elllaw.com"],
        firms: [],
        events: [],
        trialDate: null,
        firmSlug: this.$route.params.firm,
        intakeResponses
      };
      //cloud function
      console.log("new Matter =", newMatter);
      const addMatterFromIntake = firebase
        .functions()
        .httpsCallable("addMatterFromIntake");
      //ADD MATTER
      addMatterFromIntake(newMatter)
        .then(() => {
          console.log(
            "adding plaintiffs to client collection and making them users with client role"
          );
          //ADD CLIENT TO CLIENT COLLECTION
          const addClientsToClientCollection = firebase
            .functions()
            .httpsCallable("addClientsToClientCollection");
          const createUserFromClient = firebase
            .functions()
            .httpsCallable("createUserFromClient");

          this.plaintiffs.forEach(plaintiff => {
            let client = {
              clientSlug: plaintiff.partySlug,
              username: plaintiff.email,
              password: plaintiff.phone,
              partyType: plaintiff.type,
              matterSlug
            };
            console.log("adding client: ", client);
            addClientsToClientCollection(client)
              .then(() => {
                console.log("added");
              })
              .then(() => {
                //Creating Users from Clients and set user as client in auth
                console.log("Creating user from client");
                createUserFromClient(client);
              })
              .then(() => {
                console.log("done");
              })
              .catch(err => {
                console.error(err);
              });
          });
        })
        .then(() => {
          this.overlay = false;
          this.formComplete = true;
        })
        .catch(err => {
          console.error(err);
        });

      //client should know when their intake is done
    },
    addMinorToMinors() {
      this.minors.push({
        firstName: this.minorFirstName,
        lastName: this.minorLastName,
        minorGuardianName: this.minorGuardianName,
        age: this.minorAge,
        gender: this.minorGender,
        dateOfBirth: this.minorDateOfBirth,
        relation: this.minorRelation,
        minorInjured: this.minorInjured
      });
      this.minorFirstName = null;
      this.minorLastName = null;
      this.minorGuardianName = null;
      this.minorAge = null;
      this.minorGender = null;
      this.minorDateOfBirth = null;
      this.minorRelation = null;
      this.minorInjured = null;
    },
    removeMinor(i) {
      this.minors.splice(i, 1);
    },
    addAdultToAdults() {
      this.otherAdults.push({
        firstName: this.otherAdultFirstName,
        lastName: this.otherAdultLastName,
        phone: this.otherAdultPhone,
        email: this.otherAdultEmail,
        age: this.otherAdultAge,
        gender: this.otherAdultGender,
        dateOfBirth: this.otherAdultDateOfBirth,
        relation: this.otherAdultRelation,
        adultinjured: this.otherAdultInjured
      });
      this.otherAdultFirstName = null;
      this.otherAdultLastName = null;
      this.otherAdultEmail = null;
      this.otherAdultPhone = null;
      this.otherAdultAge = null;
      this.otherAdultGender = null;
      this.otherAdultDateOfBirth = null;
      this.otherAdultRelation = null;
      this.otherAdultInjured = null;
    },
    removeOtherAdult(i) {
      this.otherAdults.splice(i, 1);
    },
    logLosses() {
      console.log(this.losses);
    },
    addOtherDwellingDamage() {
      if (
        this.otherDwellingDamage !== null &&
        this.otherDwellingDamage !== undefined
      ) {
        this.losses.push(`Dwelling (Home) - ${this.otherDwellingDamage}`);
      }
    },
    addOtherStructureDamage() {
      if (
        this.otherStructureDamage !== null &&
        this.otherStructureDamage !== undefined
      ) {
        this.losses.push(
          `Other Structures (Unattached to the Home) - ${this.otherStructureDamage}`
        );
      }
    },
    addOtherContentDamage() {
      if (
        this.otherContentDamage !== null &&
        this.otherContentDamage !== undefined
      ) {
        this.losses.push(
          `Contents/Personal Property- ${this.otherContentDamage}`
        );
      }
    },
    addVehicleDamage() {
      if (
        this.vehicleDamage.description !== null &&
        this.vehicleDamage.description !== undefined
      ) {
        this.vehicles.push(this.vehicleDamage);
        // this.losses.push(
        //   `Vehicle - ${this.vehicleDamage.description} - Insured by: ${this
        //     .vehicleDamage.insurer || "NONE PROVIDED"} - Policy Number: ${this
        //     .vehicleDamage.policyNumber ||
        //     "NONE PROVIDED"} - Compensation: ${this.vehicleDamage
        //     .compensation || "NONE PROVIDED"}`
        // );
        this.vehicleDamage = {
          description: null,
          insurer: null,
          policyNumber: null,
          compensation: null
        };
      }
    },
    removeVehicle(i) {
      this.vehicles.splice(i, 1);
    }
  },
  computed: {
    // user() {
    //   return this.$store.getters.user;
    // },
    // role() {
    //   return this.$store.getters.role;
    // },
    // userIsAuthenticated() {
    //   return (
    //     this.$store.getters.user !== null &&
    //     this.$store.getters.user !== undefined
    //   );
    // },
    // firm() {
    //   return this.$store.getters.firm;
    // },
    // firmIsLoaded() {
    //   return (
    //     this.$store.getters.firm !== null &&
    //     this.$store.getters.firm !== undefined
    //   );
    // },
    // matters() {
    //   //
    //   let allMatters = this.$store.getters.matters;
    //   let woolseyMatters = allMatters.filter(
    //     (matter) =>
    //       matter.specialTitle && matter.specialTitle === `Woolsey Fire Cases`
    //   );
    //   return woolseyMatters;
    // },
    // mattersAreLoaded() {
    //   return (
    //     this.$store.getters.matters !== null &&
    //     this.$store.getters.matters !== undefined
    //   );
    // },
    // // reversedActivities() {
    // //   if (this.firm.actvities) {
    // //     return this.firm.actvities.slice().reverse();
    // //   } else {
    // //     return null;
    // //   }
    // // }
    plaintiffs() {
      let array = [];
      let alias;
      if (this.primaryFirstName && this.primaryLastName) {
        let fullName = `${this.primaryFirstName} ${this.primaryLastName}`;
        if (this.primaryPhone !== null && this.primaryPhone !== undefined) {
          alias = fullName.trim() + " " + this.primaryPhone;
        } else {
          alias = fullName.trim() + " " + this.primaryDateOfBirth;
        }

        let partySlug = slugify(alias, {
          replacement: "-",
          remove: /[$*_+~.()'"!\-:@,//]/g,
          lower: true
        });
        let newPlaintiff = {
          firstName: this.primaryFirstName,
          lastName: this.primaryLastName,
          fullName: `${this.primaryFirstName} ${this.primaryLastName}`,
          partySlug,
          addressLine1: this.streetAddress,
          cityStateZip: `${this.city}, ${this.state} ${this.zipCode}`,
          phone: this.phone,
          email: this.email,
          attorney: null,
          dateOfBirth: this.dateOfBirth,
          type: "individual",
          //experimental
          formList: [],
          insurance: [
            {
              carrier: this.insuranceCarrier,
              policyType: this.policyType,
              policyNumber: this.policyNumber
            }
          ]
        };

        array.push(newPlaintiff);

        this.otherAdults.forEach(adult => {
          let otherAdultFullName = `${adult.firstName.trim()} ${adult.lastName.trim()}`;
          let otherAdultAlias = otherAdultFullName + " " + adult.phone;
          let otherAdultPartySlug = slugify(otherAdultAlias, {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@,]/g,
            lower: true
          });
          let newAdultPlaintiff = {
            firstName: adult.firstName,
            lastName: adult.lastName,
            fullName: otherAdultFullName,
            partySlug: otherAdultPartySlug,
            addressLine1: this.streetAddress,
            cityStateZip: `${this.city}, ${this.state} ${this.zipCode}`,
            phone: adult.phone,
            email: adult.email,
            attorney: null,
            dateOfBirth: adult.dateOfBirth,
            type: "individual",
            //experimental
            formList: [],
            insurance: [
              {
                carrier: this.insuranceCarrier,
                policyType: this.policyType,
                policyNumber: this.policyNumber
              }
            ]
          };
          array.push(newAdultPlaintiff);

          this.minors.forEach(minor => {
            let minorFullName = `${minor.firstName} ${minor.lastName}`;
            let minorAlias = minorFullName + " " + minor.dateOfBirth;
            let minorPartySlug = slugify(minorAlias, {
              replacement: "-",
              remove: /[$*_+~.()'"!\-:@,/]/g,
              lower: true
            });
            let newMinorPlaintff = {
              firstName: minor.firstName,
              lastName: minor.lastName,
              fullName: minorFullName,
              partySlug: minorPartySlug,
              guardianFullName: minor.minorGuardianName,
              addressLine1: this.streetAddress,
              cityStateZip: `${this.city}, ${this.state} ${this.zipCode}`,
              phone: this.phone,
              // email: `${minor.lastName}${Date.now()}@email.com`,
              email: `${minorPartySlug}@email.com`,
              attorney: null,
              dateOfBirth: minor.dateOfBirth,
              type: "minor",
              //experimental
              formList: [],
              insurance: [
                {
                  carrier: this.insuranceCarrier,
                  policyType: this.policyType,
                  policyNumber: this.policyNumber
                }
              ]
            };
            array.push(newMinorPlaintff);
          });
        });
      }
      return array;
    }
  },
  watch: {
    primary(val) {
      if (val !== null && val !== false) {
        this.primaryFirstName = this.firstName;
        this.primaryLastName = this.lastName;
        this.primaryEmail = this.email;
        this.primaryPhone = this.phone;
        this.primaryDateOfBirth = this.dateOfBirth;
      }
      // else {
      //   this.primaryFirstName = null;
      //   this.primaryLastName = null;
      //   this.primaryEmail = null;
      //   this.primaryPhone = null;
      //   this.primaryDateOfBirth = null;
      // }
    },
    currentAddressSameAsMailing(val) {
      if (val === true) {
        this.mailingStreetAddress = this.streetAddress;
        this.mailingCity = this.city;
        this.mailingState = this.state;
        this.mailingZipCode = this.zipCode;
      } else {
        this.mailingStreetAddress = null;
        this.mailingCity = null;
        this.mailingState = null;
        this.mailingZipCode = null;
      }
    }

    // user(value) {
    //   if (value !== null && value !== undefined) {
    //     console.log("user from watch", value);
    //     // this.$store.dispatch("loadMatters", value);
    //     // this.$router.push('/');
    //     this.$store.dispatch("getFirm", this.user.firmSlug);
    //   }
    // },
    // matters(value) {
    //   if (value !== null && value !== undefined) {
    //     console.log("matters from watch", value);
    //   }
    // },
  },
  created() {
    // if (this.user) {
    //   this.$store.dispatch("getFirm", this.user.firmSlug);
    // }
    // console.log("matters:", this.matters);
  }
};
</script>
